import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Empty, message, Modal, Skeleton, Space, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { FireBaseNotificationModel } from 'features/notification/components/modal/firebaseNotificationModel';
import { SendFirebaseNotificationModal } from 'features/notification/components/modal/SendFirebaseNotificationModal';
import { NotificationCustomerFilterFormValuesPaginated } from 'features/notification/components/type';
import { useDeleteSelectedCustomers } from 'features/notification/use-cases/delete-selected-customers';
import { useMoveSelectedUserList } from 'features/notification/use-cases/move-selected-cutomer';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationCustomerList } from 'types/notification-type';
type NotificationTableProps = {
    isUsersListLoading: boolean;
    typeReportList: NotificationCustomerList[];
    itemsCount: number;
    tableParams: NotificationCustomerFilterFormValuesPaginated;
    refetch: any;
    updateParams: Dispatch<SetStateAction<NotificationCustomerFilterFormValuesPaginated>>;
    tabKey: number;
};

export const NotificationListCustomerTable = ({
    typeReportList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    refetch,
    updateParams,
    tabKey,
}: NotificationTableProps) => {
    const { t } = useTranslation();
    const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
    const [showfireBaseNotification, setShowFireBaseNotification] = useState<boolean>(false);
    const [allUser, setAllUser] = useState('')
    const [Data, setData] = useState<any>(/* Your initial data array */);
    const { confirm } = Modal;
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const getSessionId = () => {
        let id = sessionStorage.getItem("sessionId");

        if (!id) {
            id = crypto.randomUUID();
            sessionStorage.setItem("sessionId", id);
        }

        return id;
    };
    const sessionId = getSessionId();
    const { mutate } = useMoveSelectedUserList();
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<NotificationCustomerList> | SorterResult<NotificationCustomerList>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const handleOpenModal = () => {
        const selectedUsersData = getSelectedUsers();
        if (!selectedUsersData.length) {
            setShowFireBaseNotification(true)
        } else {
            setShowAddItemModal(true)
        }
        document.body.style.overflow = 'hidden';
    }

    const { mutate: mutateDeleteCustomer } =
        useDeleteSelectedCustomers();
    const handleDelete = async () => {
        const selectedUsers = getSelectedUsers();
        // ✅ Check if nothing selected
        if (!selectedUsers || selectedUsers.length === 0) {
            message.error("Please select at least one customer");

            return;
        }
        try {
            const payload = {
                SessionId: sessionId,
                ParticipatnIds: selectedUsers.map(user => ({
                    ParticipantId: user.ParticipantId,
                    UserId: user.UserId
                }))
            };

            mutateDeleteCustomer(payload);

            setSelectedRowKeys([]);

            const participantIds = selectedUsers.map(user => user.ParticipantId);

            const newData = Data.filter(
                (item: any) => !participantIds.includes(item.ParticipantId)
            );

            setData(newData);

        } catch (error) {
            console.error("error");
        }
    };
    const showDeleteConfirm = () => {
        confirm({
            title: 'Are you sure you want to delete selected customers?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete();
            },
        } as any);
    };
    const handleCloseModal = () => {
        setShowAddItemModal(false)
        document.body.style.overflow = 'visible';
    }
  
    const rowSelection = {
        selectedRowKeys,
        preserveSelectedRowKeys: true, // important for pagination
        onChange: (keys: React.Key[]) => {
            setSelectedRowKeys(keys);
        },
    };

    const getSelectedUsers = () => {
        
        return typeReportList?.filter(item =>
            selectedRowKeys.includes(item.ParticipantId)
        );
    };

// useEffect(() => {
//     if (showfireBaseNotification) {
//     }
// }, [showfireBaseNotification]);



  const handleMoveToSelected = async () => {
    const selectedUsers = getSelectedUsers();
    if (!selectedRowKeys || selectedRowKeys.length === 0) {
        message.error("Please select at least one user");
        
return;
    }

    const payload = {
        UserDataList: selectedUsers,
        SessionId: sessionId
    };

    mutate(payload, {});
    setSelectedRowKeys([]);
};

    return (
        <StyledTableWrapper>

            <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
                <SendFirebaseNotificationModal onClose={handleCloseModal} allUser={allUser} showAddItemModal={showAddItemModal} refetch={refetch} sessionId={sessionId} />
            </div>

            <StyledTableHeader>
                <RecordCountBadge
                    text={t('vendingMachine.foundRecord')}
                    count={isUsersListLoading ? 0 : itemsCount || 0}
                />
                {/* Right side: Buttons */}
                <Space>
                    {tabKey && tabKey == 1 ? (
                        <Button type="primary" onClick={handleMoveToSelected}>  Move to Selected  </Button>
                    ) : (
                        <>

                            <Button type="primary" onClick={() => handleOpenModal()}> Send Firebase Notification  </Button>

                            <Button danger onClick={showDeleteConfirm} >   Remove </Button>
                        </>
                    )}



                </Space>

            </StyledTableHeader>
            <Table<NotificationCustomerList>
                // loading={isUsersListLoading}
                // dataSource={typeReportList}
                className="cstltblwthldr"
                rowSelection={rowSelection}
                locale={{
                    emptyText: isUsersListLoading ? <Skeleton active={true} /> : <Empty />
                }}
                loading={isUsersListLoading && { indicator: <div><TableLoader /></div> }}
                dataSource={isUsersListLoading ? [] : typeReportList}
                //rowKey="ParticipantId"
                // rowKey="ParticipantId"
                rowKey={(record) =>
                    record.ParticipantId==0 ? record.UserId : record.ParticipantId 
                }
                onChange={handleTableChange}
                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >
                <Column<NotificationCustomerList>
                    title={'Customer Name '}
                    render={(_, record) =>
                        `${record?.FirstName || ""} ${record.LastName || ""}`.trim()
                    }
                />
                <Column<NotificationCustomerList>
                    title={'Gender '}
                    dataIndex={'Gender'}
                />
                <Column<NotificationCustomerList>
                    title={'Email Id '}
                    dataIndex={'Email'}
                />
                <Column<NotificationCustomerList>
                    title={' Mobile Number '}
                    dataIndex={'MobileNo'}
                />
                <Column<NotificationCustomerList>
                    title={'Nationality '}
                    dataIndex={'Nationality'}
                />


            </Table>
            {showfireBaseNotification && <FireBaseNotificationModel setShowAddItemModal={setShowAddItemModal} showfireBaseNotification={showfireBaseNotification} setAllUser={setAllUser} setShowFireBaseNotification={setShowFireBaseNotification} />}
        </StyledTableWrapper>
    );
};
